import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { upgradeMessages } from "./types";
import { styles } from "./styles";
import { ButtonBase } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { tierMap } from "../../pages/Billing/types";
import Mixpanel from "../../utils/mixpanel";
import Slide from "@mui/material/Slide";
import { FONT_FAMILY } from "../../theme";

export const SubscriptionUpgradePopUp: React.FC<{
  subscriptionTier: number;
}> = ({ subscriptionTier }): JSX.Element => {
  const [open, setOpen] = useState(true);
  const [upgradeMessage, setUpgradeMessage] = useState<string>("");
  const tier = tierMap[subscriptionTier];
  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
  };

  const handleUpgrade = () => {
    setOpen(false);
    Mixpanel.track("upgrade_popup_click", { message: upgradeMessage });
    navigate("/billing");
  };

  useEffect(() => {
    const randomUpgradeMessage =
      upgradeMessages[Math.floor(Math.random() * upgradeMessages.length)];
    setUpgradeMessage(randomUpgradeMessage);
  }, []);

  return (
    <div>
      {open && tier === "Minor" && (
        <Slide direction="right" in={open}>
          <Box sx={styles.popupContainer}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: "22px" }}>
                {" "}
                {upgradeMessage}
              </Typography>
              <ButtonBase onClick={handleUpgrade} sx={styles.upgradeButton}>
                Upgrade
              </ButtonBase>
              <CloseIcon sx={styles.closeIcon} onClick={handleClose} />
            </Box>
          </Box>
        </Slide>
      )}
    </div>
  );
};
